import React from "react";

const MetricsChartPatterns = () => (
    <pattern
        id = "NoDataPattern"
        patternUnits = "userSpaceOnUse"
        width = "20"
        height = "40"
        patternTransform = "scale(0.5)"
    >
        <rect x = "0" y = "0" width = "100%" height = "100%" fill = "white"/>
        <path
            d = "M0 30h5M10 30h5M20 30h5M30 30h5M40 30h5"
            strokeWidth = "2"
            stroke = "#1976d2"
            fill = "none"
        />
        <path
            d = "M0 10h5M10 10h5M20 30h5M30 30h5M40 30h5"
            strokeWidth = "2"
            stroke = "#1976d2"
            fill = "none"
        />
    </pattern>
);

export default MetricsChartPatterns;
